import { useMemo } from "react";
import { useLocation } from "wouter";
import { FALLBACK_DOMAIN } from "../lib/constants";

const LOCALHOST_DOMAIN = "localhost";

const useDomain = ({ fallback = FALLBACK_DOMAIN } = {}) => {
  const [location] = useLocation();

  const domain = useMemo(() => {
    const hostname = window.location.hostname;
    const domain = hostname.split(".").slice(-2).join(".");

    if (domain === LOCALHOST_DOMAIN) {
      return fallback;
    }

    return domain;
  }, [location]);

  return domain;
};

export default useDomain;
